import React from 'react';
import isInt from 'validator/lib/isInt';
import {
  Button,
  Confirm,
  Form,
  FormField,
  Grid,
  Segment,
} from 'semantic-ui-react';
import { Field, Form as FinalForm } from 'react-final-form';
import ValidatedTextArea from 'components/ValidatedTextArea';
import { requiredStringValidation } from 'utils/formUtils';
import PropTypes from 'prop-types';
import LogModal from 'pages/BulkDeleteBusiness/LogModal';
import { confirmProcess } from 'state/bulkDeleteBusiness/actions';
import { useDispatch, useSelector } from 'react-redux';

function parseBusinessIds(businessIds) {
  if (!businessIds) {
    return '';
  }
  return businessIds.replace(/[^\d\n]/g, '');
}

function countIdsAll(ids) {
  return (ids || '').split('\n').filter(i => isInt(i, { min: 0 })).length;
}

function countDistinct(ids) {
  const rawArray = (ids || '').split('\n');
  return [...new Set(rawArray)].filter(i => isInt(i, { min: 0 })).length;
}

const renderForm = ({ handleSubmit, values }) => {
  const countAll = countIdsAll(values.business_ids);
  const duplicateCount = countAll - countDistinct(values.business_ids);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid columns="equal">
        <Grid.Column width={8}>
          <FormField>
            <label htmlFor="business-ids">
              Insert business IDs here separated with line breaks
            </label>
            <Field
              id="business-ids"
              name="business_ids"
              component={ValidatedTextArea}
              parse={parseBusinessIds}
              validate={requiredStringValidation()}
              style={{ minHeight: '500px' }}
            />
          </FormField>
        </Grid.Column>
        <Grid.Column>
          <div>
            Count: {countAll}{' '}
            {duplicateCount > 0 ? `(${duplicateCount} duplicates)` : ''}
          </div>
          <br />
          <Button negative type="submit">
            Delete
          </Button>
        </Grid.Column>
      </Grid>
    </Form>
  );
};

renderForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

function MainPage({ onSubmit, onShowLogButtonClicked }) {
  const dispatch = useDispatch();
  const confirmModalShown = useSelector(
    state => state.bulkDeleteBusiness.confirmModalShown
  );

  return (
    <>
      <LogModal />
      <Confirm
        open={confirmModalShown}
        confirmButton={{ negative: true, content: 'Confirm' }}
        onCancel={() => dispatch(confirmProcess(false))}
        onConfirm={() => dispatch(confirmProcess(true))}
        header="Confirm Bulk Delete Business"
        content="Are you sure to perform this operation? Any progress cannot be rolled back"
      />
      <Button basic color="black" onClick={onShowLogButtonClicked}>
        Show Logs
      </Button>
      <Segment>
        <h3>Business IDs</h3>
        <FinalForm render={renderForm} onSubmit={onSubmit} />
      </Segment>
    </>
  );
}

MainPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onShowLogButtonClicked: PropTypes.func.isRequired,
};

export default MainPage;
